<template>
	<div
		class="flex flex-col gap-2 rounded border p-2 self-start items-start bg-[var(--background-secondary)] text-sm"
	>
		<div>
			<div class="flex gap-1 items-center">
				<img
					v-if="
						existingMortgage.lenderCode &&
						getLenderOption(existingMortgage.lenderCode)
					"
					:src="`/logos/${getLenderOption(existingMortgage.lenderCode)?.icon}`"
					class="w-4 h-4"
				/>
				<span>{{ titleForMortgage(existingMortgage) }}</span>
			</div>

			<RouterLink
				class="text-sm text-[var(--text-secondary)] hover:underline pl-5"
				:to="{ name: 'HuidigeHypotheek' }"
			>
				<span> Hypotheek bewerken </span>
			</RouterLink>
		</div>

		<span class="text-[var(--text-secondary)]">
			{{
				(existingMortgage.mortgageParts?.length ?? 0) -
				partsNotConnected.length
			}}/{{ existingMortgage.mortgageParts?.length }} leningdelen
			meegenomen</span
		>

		<AppButton
			v-if="existingMortgage.mortgageParts"
			:variant="partsNotConnected.length === 0 ? 'success' : 'secondary'"
			:icon="partsNotConnected.length === 0 ? 'check' : undefined"
			:disabled="partsNotConnected.length === 0"
			@click="emit('apply', partsNotConnected)"
		>
			{{ buttonText }}
		</AppButton>
	</div>
</template>

<script setup lang="ts">
import type {
	ExistingMortgage,
	ExistingMortgagePart,
	MortgagePart,
} from "@loanlink-nl/model-app";
import { useProviderLenders } from "@/composables/useProviderLenders";
import { titleForMortgage } from "@/components/existing-mortgage/title-for-mortgage";
import { computed } from "vue";

const props = defineProps<{
	existingMortgage: ExistingMortgage;
	mortgageParts: MortgagePart[];
}>();

const emit = defineEmits<{
	(e: "apply", partsNotConnected: ExistingMortgagePart[]): void;
}>();

const { getLenderOption } = useProviderLenders();

const partsNotConnected = computed(() => {
	const partsNotConnected: ExistingMortgagePart[] = [];
	for (const part of props.existingMortgage.mortgageParts ?? []) {
		const partIsConnected = props.mortgageParts.some(
			(mortgagePart) => mortgagePart.existingMortgagePartId === part.id,
		);
		if (!partIsConnected) {
			partsNotConnected.push(part);
		}
	}

	return partsNotConnected;
});

const buttonText = computed(() => {
	if (partsNotConnected.value.length === 0) {
		return "Hypotheek meegenomen";
	}

	if (partsNotConnected.value.length === 1) {
		return "Neem 1 leningdeel mee";
	}

	return `Neem ${partsNotConnected.value.length} leningdelen mee`;
});
</script>
